/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  BrandConfigurationResponseCollectionResponse,
  CalculationConfigurationResponseDataResponse,
  CalculationDeletePickingPositionsRequest,
  CalculationDepartmentResponseCollectionResponse,
  CalculationDetailResponseDataResponse,
  CalculationEvaluationRatesSummaryResponseDataResponse,
  CalculationExperimentalConfigurationResponseCollectionResponse,
  CalculationFileResponseCollectionResponse,
  CalculationImportRequest,
  CalculationImportResponseDataResponse,
  CalculationPickingExecutionDetailsResponseDataResponse,
  CalculationPickingInsightsSummaryResponseDataResponse,
  CalculationPickingIssuesResponseCollectionResponse,
  CalculationPickingPerformanceCollectionResponse,
  CalculationPickingResponseDataResponse,
  CalculationRecordImportItemResponseCollectionResponse,
  CalculationRecordImportSummaryResponseCollectionResponse,
  CalculationRequest,
  CalculationRoutesDeleteRequest,
  CalculationSourceStoresDeleteRequest,
  CalculationStatisticClusterType,
  CalculationStatisticRegionResponseCollectionResponse,
  CalculationStatisticRequestListItemResponseCollectionResponse,
  CalculationStatisticRequestListItemSourceResponseCollectionResponse,
  CalculationStatisticRequestListSummaryResponseDataResponse,
  CalculationStatisticRouteResponseCollectionResponse,
  CalculationStatisticRouteSummaryResponseCollectionResponse,
  CalculationStatisticSkuClassResponseCollectionResponse,
  CalculationStatisticStoreSourceResponseCollectionResponse,
  CalculationStatisticStoreSummaryResponseDataResponse,
  CalculationStatisticStoreTargetResponseCollectionResponse,
  CalculationStatisticStoreTypeResponseCollectionResponse,
  CalculationStatisticSummaryResponseDataResponse,
  CalculationTargetStoresDeleteRequest,
  CalculationUpdateRequest,
  CalculationWithRelatedEntitiesResponseCollectionResponse,
  CategoryFieldConfigurationResponseCollectionResponse,
  CategoryInsightsResponseDataResponse,
  CategorySkuCountResponseCollectionResponse,
  CategoryWarehouseOverviewResponseCollectionResponse,
  Condition,
  ConfigurationRuleResponseCollectionResponse,
  CustomExportRunItemResponseCollectionResponse,
  CustomExportRunItemResponseDataResponse,
  CustomExportRunPatchRequest,
  CustomExportRunResponseCollectionResponse,
  CustomExportRunResponseDataResponse,
  CustomExportRunType,
  ErrorResponse,
  ForecastMonthlyOverviewResponseCollectionResponse,
  NonSaleDailyOverviewResponseCollectionResponse,
  PapPackingPictureType,
  PickingIssueResponseCollectionResponse,
  PickingPositionResponseCollectionResponse,
  ProductListConfigurationResponseCollectionResponse,
  RecordImportItemsRequest,
  RecordImportVerificationRequest,
  RegionFlowGroupResponseCollectionResponse,
  RegionResponseCollectionResponse,
  SaleDailyOverviewResponseCollectionResponse,
  SaleMonthlyOverviewResponseCollectionResponse,
  ScopeEntityConfigurationResponseCollectionResponse,
  SkuAttributeResponseCollectionResponse,
  SkuCalculationConfigurationResponseDataResponse,
  SkuClassConfigurationResponseCollectionResponse,
  SkuRedistributionChangelogCollectionResponse,
  SkuRedistributionResponseCollectionResponse,
  Sorting,
  SourceStoreEvaluationRatesResponseCollectionResponse,
  StorePickingInsightsResponseCollectionResponse,
  StoreResponseCollectionResponse,
  StoreScheduleExclusionResponseCollectionResponse,
  StoreScheduleStoreExclusionResponseCollectionResponse,
  StoreTypeResponseCollectionResponse,
  TargetStoreEvaluationRatesResponseCollectionResponse,
  ValidationArea,
  ValidationProblemResponseCollectionResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';
export class Calculations<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculations
   * @request GET:/Calculations
   * @response `200` `CalculationWithRelatedEntitiesResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculations = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationWithRelatedEntitiesResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name CalculationsCreate
   * @request POST:/Calculations
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  calculationsCreate = (data: CalculationRequest, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculation
   * @request GET:/Calculations/{id}
   * @response `200` `CalculationDetailResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculation = (id: number, params: RequestParams = {}) =>
    this.http.request<CalculationDetailResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name PatchCalculation
   * @request PATCH:/Calculations/{id}
   * @response `200` `CalculationDetailResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  patchCalculation = (id: number, data: CalculationUpdateRequest, params: RequestParams = {}) =>
    this.http.request<CalculationDetailResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name DeleteCalculation
   * @request DELETE:/Calculations/{id}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteCalculation = (id: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations/${id}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name PatchCalculationPairings
   * @request PATCH:/Calculations/{id}/Pairings
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  patchCalculationPairings = (id: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations/${id}/Pairings`,
      method: 'PATCH',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name CreateCalculationImport
   * @request POST:/Calculations/{id}/Import
   * @response `200` `CalculationImportResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  createCalculationImport = (
    id: number,
    data: CalculationImportRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationImportResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${id}/Import`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationImport
   * @request GET:/Calculations/{id}/Import
   * @response `200` `CalculationImportResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationImport = (id: number, params: RequestParams = {}) =>
    this.http.request<CalculationImportResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${id}/Import`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name DeleteCalculationImport
   * @request DELETE:/Calculations/{id}/Import
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteCalculationImport = (
    id: number,
    data: RecordImportVerificationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations/${id}/Import`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name PutCalculationImportItems
   * @request PUT:/Calculations/{id}/ImportItems
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  putCalculationImportItems = (
    id: number,
    data: RecordImportItemsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations/${id}/ImportItems`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationImportItems
   * @request GET:/Calculations/{id}/ImportItems
   * @response `200` `CalculationRecordImportItemResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationImportItems = (
    id: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationRecordImportItemResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/ImportItems`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name PutCalculationItems
   * @request PUT:/Calculations/{id}/Items
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  putCalculationItems = (
    id: number,
    data: RecordImportVerificationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations/${id}/Items`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationImportSummary
   * @request GET:/Calculations/{id}/ImportSummary
   * @response `200` `CalculationRecordImportSummaryResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationImportSummary = (id: number, params: RequestParams = {}) =>
    this.http.request<CalculationRecordImportSummaryResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/ImportSummary`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationBrands
   * @request GET:/Calculations/{id}/Brands
   * @response `200` `BrandConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationBrands = (
    id: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<BrandConfigurationResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/Brands`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationCategories
   * @request GET:/Calculations/{id}/Categories
   * @response `200` `CategorySkuCountResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationCategories = (
    id: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CategorySkuCountResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/Categories`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationCategoryConfigurations
   * @request GET:/Calculations/{id}/Categories/{categoryId}/Configurations
   * @response `200` `CategoryFieldConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationCategoryConfigurations = (
    id: number,
    categoryId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<CategoryFieldConfigurationResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/Categories/${categoryId}/Configurations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationCategoryInsights
   * @request GET:/Calculations/{id}/Categories/{categoryId}/Insights
   * @response `200` `CategoryInsightsResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationCategoryInsights = (id: number, categoryId: number, params: RequestParams = {}) =>
    this.http.request<CategoryInsightsResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${id}/Categories/${categoryId}/Insights`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationCategoryPairings
   * @request GET:/Calculations/{id}/Categories/{categoryId}/Pairings
   * @response `200` `SkuRedistributionResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationCategoryPairings = (
    id: number,
    categoryId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<SkuRedistributionResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/Categories/${categoryId}/Pairings`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationCategoryWarehouseOverview
   * @request GET:/Calculations/{id}/Categories/{categoryId}/WarehouseOverviews
   * @deprecated
   * @response `200` `CategoryWarehouseOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationCategoryWarehouseOverview = (
    id: number,
    categoryId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<CategoryWarehouseOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/Categories/${categoryId}/WarehouseOverviews`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationConfigurations
   * @request GET:/Calculations/{id}/Configurations
   * @response `200` `CalculationConfigurationResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationConfigurations = (id: number, params: RequestParams = {}) =>
    this.http.request<CalculationConfigurationResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${id}/Configurations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationExperimentalConfigurations
   * @request GET:/Calculations/{id}/ExperimentalConfigurations
   * @response `200` `CalculationExperimentalConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationExperimentalConfigurations = (id: number, params: RequestParams = {}) =>
    this.http.request<
      CalculationExperimentalConfigurationResponseCollectionResponse,
      ErrorResponse
    >({
      path: `/Calculations/${id}/ExperimentalConfigurations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationDeviations
   * @request GET:/Calculations/{id}/Deviations
   * @response `200` `CategoryFieldConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationDeviations = (id: number, params: RequestParams = {}) =>
    this.http.request<CategoryFieldConfigurationResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/Deviations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationProductListsV2
   * @request GET:/Calculations/{id}/ProductLists/V2
   * @response `200` `ProductListConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationProductListsV2 = (
    id: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<ProductListConfigurationResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/ProductLists/V2`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCustomExportRuns
   * @request GET:/Calculations/{calculationId}/CustomExportRuns
   * @response `200` `CustomExportRunResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCustomExportRuns = (
    calculationId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CustomExportRunResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/CustomExportRuns`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name CreateCustomExportRun
   * @request POST:/Calculations/{calculationId}/CustomExportRuns
   * @response `200` `CustomExportRunResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  createCustomExportRun = (
    calculationId: number,
    query?: {
      type?: CustomExportRunType;
      /** @default false */
      skipCommandQueue?: boolean;
      /** @default false */
      allowNonProduction?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CustomExportRunResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/CustomExportRuns`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name UpdateCustomExportRun
   * @request PATCH:/Calculations/{calculationId}/CustomExportRuns/{customExportRunId}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  updateCustomExportRun = (
    calculationId: number,
    customExportRunId: number,
    data: CustomExportRunPatchRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations/${calculationId}/CustomExportRuns/${customExportRunId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCustomExportRunItems
   * @request GET:/Calculations/{calculationId}/CustomExportRuns/{customExportRunId}/Items
   * @response `200` `CustomExportRunItemResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCustomExportRunItems = (
    calculationId: number,
    customExportRunId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CustomExportRunItemResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/CustomExportRuns/${customExportRunId}/Items`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCustomExportRunItemDetail
   * @request GET:/Calculations/{calculationId}/CustomExportRuns/{customExportRunId}/Items/{customExportRunItemId}/Detail
   * @response `200` `CustomExportRunItemResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCustomExportRunItemDetail = (
    calculationId: number,
    customExportRunId: number,
    customExportRunItemId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<CustomExportRunItemResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/CustomExportRuns/${customExportRunId}/Items/${customExportRunItemId}/Detail`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationFiles
   * @request GET:/Calculations/{calculationId}/Files
   * @response `200` `CalculationFileResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationFiles = (
    calculationId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationFileResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Files`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationFile
   * @request GET:/Calculations/{calculationId}/Files/{id}
   * @response `200` `CalculationFileResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationFile = (calculationId: number, id: number, params: RequestParams = {}) =>
    this.http.request<CalculationFileResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Files/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationRegions
   * @request GET:/Calculations/{calculationId}/Regions
   * @response `200` `RegionResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationRegions = (
    calculationId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<RegionResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Regions`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationSkuClassConfigurations
   * @request GET:/Calculations/{id}/SkuClasses/Configurations
   * @response `200` `SkuClassConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationSkuClassConfigurations = (id: number, params: RequestParams = {}) =>
    this.http.request<SkuClassConfigurationResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/SkuClasses/Configurations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationSkus
   * @request GET:/Calculations/{id}/Skus/{skuId}
   * @response `200` `SkuCalculationConfigurationResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationSkus = (id: number, skuId: number, params: RequestParams = {}) =>
    this.http.request<SkuCalculationConfigurationResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${id}/Skus/${skuId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationSkuAttributes
   * @request GET:/Calculations/{id}/Skus/{skuId}/Attributes
   * @response `200` `SkuAttributeResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationSkuAttributes = (id: number, skuId: number, params: RequestParams = {}) =>
    this.http.request<SkuAttributeResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/Skus/${skuId}/Attributes`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationSkuMonthlySaleWithinMonthsRange
   * @request GET:/Calculations/{id}/Skus/{skuId}/MonthlySales/MonthsRange/{monthsRange}
   * @response `200` `SaleMonthlyOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationSkuMonthlySaleWithinMonthsRange = (
    id: number,
    skuId: number,
    monthsRange: number,
    params: RequestParams = {},
  ) =>
    this.http.request<SaleMonthlyOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/Skus/${skuId}/MonthlySales/MonthsRange/${monthsRange}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationSkuDailySaleWithinMonthsRange
   * @request GET:/Calculations/{id}/Skus/{skuId}/DailySales/MonthsRange/{monthsRange}
   * @response `200` `SaleDailyOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationSkuDailySaleWithinMonthsRange = (
    id: number,
    skuId: number,
    monthsRange: number,
    params: RequestParams = {},
  ) =>
    this.http.request<SaleDailyOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/Skus/${skuId}/DailySales/MonthsRange/${monthsRange}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationSkuDailyInboundsWithinMonthsRange
   * @request GET:/Calculations/{id}/Skus/{skuId}/DailyInbounds/MonthsRange/{monthsRange}
   * @response `200` `NonSaleDailyOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationSkuDailyInboundsWithinMonthsRange = (
    id: number,
    skuId: number,
    monthsRange: number,
    params: RequestParams = {},
  ) =>
    this.http.request<NonSaleDailyOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/Skus/${skuId}/DailyInbounds/MonthsRange/${monthsRange}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationSkuDailyOutboundsWithinMonthsRange
   * @request GET:/Calculations/{id}/Skus/{skuId}/DailyOutbounds/MonthsRange/{monthsRange}
   * @response `200` `NonSaleDailyOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationSkuDailyOutboundsWithinMonthsRange = (
    id: number,
    skuId: number,
    monthsRange: number,
    params: RequestParams = {},
  ) =>
    this.http.request<NonSaleDailyOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/Skus/${skuId}/DailyOutbounds/MonthsRange/${monthsRange}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationSkuMonthlyForecast
   * @request GET:/Calculations/{id}/Skus/{skuId}/MonthlyForecasts
   * @response `200` `ForecastMonthlyOverviewResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationSkuMonthlyForecast = (id: number, skuId: number, params: RequestParams = {}) =>
    this.http.request<ForecastMonthlyOverviewResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/Skus/${skuId}/MonthlyForecasts`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetPickingPositionsWithinProductGroup
   * @request GET:/Calculations/{id}/PickingPositions/SourceSkuId/{sourceSkuId}/TargetSkuId/{targetSkuId}/ProductGroups/{productGroupId}
   * @response `200` `PickingPositionResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getPickingPositionsWithinProductGroup = (
    id: number,
    sourceSkuId: number,
    targetSkuId: number,
    productGroupId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<PickingPositionResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/PickingPositions/SourceSkuId/${sourceSkuId}/TargetSkuId/${targetSkuId}/ProductGroups/${productGroupId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatistics
   * @request GET:/Calculations/{calculationId}/Statistics
   * @response `200` `CalculationStatisticSummaryResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatistics = (
    calculationId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticSummaryResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticsByDepartment
   * @request GET:/Calculations/{calculationId}/Statistics/Departments/{departmentId}
   * @response `200` `CalculationStatisticSummaryResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticsByDepartment = (
    calculationId: number,
    departmentId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticSummaryResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Departments/${departmentId}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticRouteSummaries
   * @request GET:/Calculations/{calculationId}/Statistics/RouteSummaries
   * @response `200` `CalculationStatisticRouteSummaryResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticRouteSummaries = (
    calculationId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticRouteSummaryResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/RouteSummaries`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticRouteSummariesByDepartment
   * @request GET:/Calculations/{calculationId}/Statistics/Departments/{departmentId}/RouteSummaries
   * @response `200` `CalculationStatisticRouteSummaryResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticRouteSummariesByDepartment = (
    calculationId: number,
    departmentId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticRouteSummaryResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Departments/${departmentId}/RouteSummaries`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticRoutes
   * @request GET:/Calculations/{calculationId}/Statistics/Routes
   * @response `200` `CalculationStatisticRouteResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticRoutes = (
    calculationId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticRouteResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Routes`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticRoutesByDepartment
   * @request GET:/Calculations/{calculationId}/Statistics/Departments/{departmentId}/Routes
   * @response `200` `CalculationStatisticRouteResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticRoutesByDepartment = (
    calculationId: number,
    departmentId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticRouteResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Departments/${departmentId}/Routes`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticSourceStoreSummaries
   * @request GET:/Calculations/{calculationId}/Statistics/StoreSummaries
   * @response `200` `CalculationStatisticStoreSummaryResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticSourceStoreSummaries = (
    calculationId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticStoreSummaryResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/StoreSummaries`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticSourceStoreSummariesByDepartment
   * @request GET:/Calculations/{calculationId}/Statistics/Departments/{departmentId}/StoreSummaries
   * @response `200` `CalculationStatisticStoreSummaryResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticSourceStoreSummariesByDepartment = (
    calculationId: number,
    departmentId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticStoreSummaryResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Departments/${departmentId}/StoreSummaries`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticSourceStores
   * @request GET:/Calculations/{calculationId}/Statistics/SourceStores
   * @response `200` `CalculationStatisticStoreSourceResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticSourceStores = (
    calculationId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticStoreSourceResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/SourceStores`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticSourceStoresByDepartment
   * @request GET:/Calculations/{calculationId}/Statistics/Departments/{departmentId}/SourceStores
   * @response `200` `CalculationStatisticStoreSourceResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticSourceStoresByDepartment = (
    calculationId: number,
    departmentId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticStoreSourceResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Departments/${departmentId}/SourceStores`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticTargetStores
   * @request GET:/Calculations/{calculationId}/Statistics/TargetStores
   * @response `200` `CalculationStatisticStoreTargetResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticTargetStores = (
    calculationId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticStoreTargetResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/TargetStores`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticTargetStoresByDepartment
   * @request GET:/Calculations/{calculationId}/Statistics/Departments/{departmentId}/TargetStores
   * @response `200` `CalculationStatisticStoreTargetResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticTargetStoresByDepartment = (
    calculationId: number,
    departmentId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticStoreTargetResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Departments/${departmentId}/TargetStores`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticRegions
   * @request GET:/Calculations/{calculationId}/Statistics/Regions
   * @response `200` `CalculationStatisticRegionResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticRegions = (
    calculationId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticRegionResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Regions`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticRegionsByDepartment
   * @request GET:/Calculations/{calculationId}/Statistics/Departments/{departmentId}/Regions
   * @response `200` `CalculationStatisticRegionResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticRegionsByDepartment = (
    calculationId: number,
    departmentId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticRegionResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Departments/${departmentId}/Regions`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticSkuClasses
   * @request GET:/Calculations/{calculationId}/Statistics/SkuClasses
   * @response `200` `CalculationStatisticSkuClassResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticSkuClasses = (
    calculationId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticSkuClassResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/SkuClasses`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticSkuClassesByDepartment
   * @request GET:/Calculations/{calculationId}/Statistics/Departments/{departmentId}/SkuClasses
   * @response `200` `CalculationStatisticSkuClassResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticSkuClassesByDepartment = (
    calculationId: number,
    departmentId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticSkuClassResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Departments/${departmentId}/SkuClasses`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticStoreTypes
   * @request GET:/Calculations/{calculationId}/Statistics/StoreTypes
   * @response `200` `CalculationStatisticStoreTypeResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticStoreTypes = (
    calculationId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticStoreTypeResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/StoreTypes`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticStoreTypesByDepartment
   * @request GET:/Calculations/{calculationId}/Statistics/Departments/{departmentId}/StoreTypes
   * @response `200` `CalculationStatisticStoreTypeResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticStoreTypesByDepartment = (
    calculationId: number,
    departmentId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticStoreTypeResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Departments/${departmentId}/StoreTypes`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticRequestListSummary
   * @summary Summary of the quantity requested and received for configured request list.
   * @request GET:/Calculations/{calculationId}/Statistics/RequestListSummary
   * @response `200` `CalculationStatisticRequestListSummaryResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticRequestListSummary = (calculationId: number, params: RequestParams = {}) =>
    this.http.request<CalculationStatisticRequestListSummaryResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/RequestListSummary`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticRequestListItems
   * @summary Content of the request list with requested and received quantities for each SKU.
   * @request GET:/Calculations/{calculationId}/Statistics/RequestListItems
   * @response `200` `CalculationStatisticRequestListItemResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticRequestListItems = (
    calculationId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationStatisticRequestListItemResponseCollectionResponse, ErrorResponse>(
      {
        path: `/Calculations/${calculationId}/Statistics/RequestListItems`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      },
    );
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticRequestListItemSources
   * @summary List of sources for given target SKU in the request list with quantities sent by each source and other statistics.
   * @request GET:/Calculations/{calculationId}/Statistics/RequestListItems/{targetSkuId}/Sources
   * @response `200` `CalculationStatisticRequestListItemSourceResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticRequestListItemSources = (
    calculationId: number,
    targetSkuId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      CalculationStatisticRequestListItemSourceResponseCollectionResponse,
      ErrorResponse
    >({
      path: `/Calculations/${calculationId}/Statistics/RequestListItems/${targetSkuId}/Sources`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticsEvaluationRates
   * @request GET:/Calculations/{calculationId}/Statistics/EvaluationRates
   * @response `200` `CalculationEvaluationRatesSummaryResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticsEvaluationRates = (
    calculationId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationEvaluationRatesSummaryResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/EvaluationRates`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticsExecutionRatesByDepartment
   * @request GET:/Calculations/{calculationId}/Statistics/Departments/{departmentId}/EvaluationRates
   * @response `200` `CalculationEvaluationRatesSummaryResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticsExecutionRatesByDepartment = (
    calculationId: number,
    departmentId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationEvaluationRatesSummaryResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Departments/${departmentId}/EvaluationRates`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticsSourceStoresEvaluationRates
   * @request GET:/Calculations/{calculationId}/Statistics/EvaluationRates/SourceStores
   * @response `200` `SourceStoreEvaluationRatesResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticsSourceStoresEvaluationRates = (
    calculationId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<SourceStoreEvaluationRatesResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/EvaluationRates/SourceStores`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticsSourceStoresEvaluationRatesByDepartment
   * @request GET:/Calculations/{calculationId}/Statistics/Departments/{departmentId}/EvaluationRates/SourceStores
   * @response `200` `SourceStoreEvaluationRatesResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticsSourceStoresEvaluationRatesByDepartment = (
    calculationId: number,
    departmentId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<SourceStoreEvaluationRatesResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Departments/${departmentId}/EvaluationRates/SourceStores`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticsSourceStoresEvaluationRatesCsvFile
   * @request GET:/Calculations/{calculationId}/Statistics/EvaluationRates/SourceStores/Csv
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticsSourceStoresEvaluationRatesCsvFile = (
    calculationId: number,
    query?: {
      /** @default "Store" */
      clusterType?: CalculationStatisticClusterType;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/EvaluationRates/SourceStores/Csv`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticsSourceStoreTargetStoresExecutionRates
   * @request GET:/Calculations/{calculationId}/Statistics/EvaluationRates/SourceStores/{sourceStoreId}/TargetStores
   * @response `200` `TargetStoreEvaluationRatesResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticsSourceStoreTargetStoresExecutionRates = (
    calculationId: number,
    sourceStoreId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<TargetStoreEvaluationRatesResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/EvaluationRates/SourceStores/${sourceStoreId}/TargetStores`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticsSourceStoreTargetStoresExecutionRatesByDepartment
   * @request GET:/Calculations/{calculationId}/Statistics/Departments/{departmentId}/EvaluationRates/SourceStores/{sourceStoreId}/TargetStores
   * @response `200` `TargetStoreEvaluationRatesResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticsSourceStoreTargetStoresExecutionRatesByDepartment = (
    calculationId: number,
    departmentId: number,
    sourceStoreId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<TargetStoreEvaluationRatesResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Departments/${departmentId}/EvaluationRates/SourceStores/${sourceStoreId}/TargetStores`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationPicking
   * @summary Overall picking results and status for a calculation.
   * @request GET:/Calculations/{calculationId}/Statistics/Picking
   * @response `200` `CalculationPickingResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationPicking = (calculationId: number, params: RequestParams = {}) =>
    this.http.request<CalculationPickingResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Picking`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationPickingInsightsSummary
   * @summary Statistical data about the picking process for the whole calculation
   * @request GET:/Calculations/{calculationId}/Statistics/Picking/Insights
   * @response `200` `CalculationPickingInsightsSummaryResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationPickingInsightsSummary = (calculationId: number, params: RequestParams = {}) =>
    this.http.request<CalculationPickingInsightsSummaryResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Picking/Insights`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationPickingInsights
   * @summary Statistical data about the picking process of source stores like the average picking time per SKU
   * @request GET:/Calculations/{calculationId}/Statistics/Picking/Insights/SourceStores
   * @response `200` `StorePickingInsightsResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationPickingInsights = (calculationId: number, params: RequestParams = {}) =>
    this.http.request<StorePickingInsightsResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Picking/Insights/SourceStores`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetSourceStorePickingInsights
   * @summary Statistical data about the picking process of a source store for each target store
   * @request GET:/Calculations/{calculationId}/Statistics/Picking/Insights/SourceStores/{sourceStoreId}
   * @response `200` `StorePickingInsightsResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getSourceStorePickingInsights = (
    calculationId: number,
    sourceStoreId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<StorePickingInsightsResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Picking/Insights/SourceStores/${sourceStoreId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationPickingIssues
   * @summary Picking issues for a calculation for each source store
   * @request GET:/Calculations/{calculationId}/Statistics/Picking/Issues
   * @response `200` `CalculationPickingIssuesResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationPickingIssues = (calculationId: number, params: RequestParams = {}) =>
    this.http.request<CalculationPickingIssuesResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Picking/Issues`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetSkusWithIssues
   * @summary Picking issues for all source stores
   * @request GET:/Calculations/{calculationId}/Statistics/Picking/Issues/SourceStores
   * @response `200` `PickingIssueResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getSkusWithIssues = (
    calculationId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<PickingIssueResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Picking/Issues/SourceStores`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetSkusWithIssuesForSourceStore
   * @summary Picking issues for a source store
   * @request GET:/Calculations/{calculationId}/Statistics/Picking/Issues/SourceStores/{sourceStoreId}
   * @response `200` `PickingIssueResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getSkusWithIssuesForSourceStore = (
    calculationId: number,
    sourceStoreId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<PickingIssueResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Picking/Issues/SourceStores/${sourceStoreId}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetPickingPerformances
   * @request GET:/Calculations/{calculationId}/Statistics/Picking/Performances
   * @response `200` `CalculationPickingPerformanceCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getPickingPerformances = (calculationId: number, params: RequestParams = {}) =>
    this.http.request<CalculationPickingPerformanceCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Picking/Performances`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetPackingPictureFile
   * @request GET:/Calculations/{calculationId}/Statistics/Picking/SourceStores/{sourceStoreId}/TargetStores/{targetStoreId}/Pictures/Box/{boxNumber}/Type/{pictureTypeId}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getPackingPictureFile = (
    calculationId: number,
    sourceStoreId: number,
    targetStoreId: number,
    boxNumber: number,
    pictureTypeId: PapPackingPictureType,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Picking/SourceStores/${sourceStoreId}/TargetStores/${targetStoreId}/Pictures/Box/${boxNumber}/Type/${pictureTypeId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetPackingPictureFileByDepartment
   * @request GET:/Calculations/{calculationId}/Statistics/Picking/Departments/{departmentId}/SourceStores/{sourceStoreId}/TargetStores/{targetStoreId}/Pictures/Box/{boxNumber}/Type/{pictureTypeId}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getPackingPictureFileByDepartment = (
    calculationId: number,
    departmentId: number,
    sourceStoreId: number,
    targetStoreId: number,
    boxNumber: number,
    pictureTypeId: PapPackingPictureType,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Picking/Departments/${departmentId}/SourceStores/${sourceStoreId}/TargetStores/${targetStoreId}/Pictures/Box/${boxNumber}/Type/${pictureTypeId}`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStatisticsExecutionDetails
   * @request GET:/Calculations/{calculationId}/Statistics/Execution/SourceSku/{sourceSkuId}/TargetSku/{targetSkuId}
   * @response `200` `CalculationPickingExecutionDetailsResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStatisticsExecutionDetails = (
    calculationId: number,
    sourceSkuId: number,
    targetSkuId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationPickingExecutionDetailsResponseDataResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Statistics/Execution/SourceSku/${sourceSkuId}/TargetSku/${targetSkuId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetRegionFlowGroups
   * @request GET:/Calculations/{id}/RegionFlowGroups
   * @response `200` `RegionFlowGroupResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getRegionFlowGroups = (id: number, params: RequestParams = {}) =>
    this.http.request<RegionFlowGroupResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${id}/RegionFlowGroups`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStores
   * @request GET:/Calculations/{calculationId}/Stores
   * @response `200` `StoreResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStores = (
    calculationId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<StoreResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Stores`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStoreTypes
   * @request GET:/Calculations/{calculationId}/StoreTypes
   * @response `200` `StoreTypeResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStoreTypes = (
    calculationId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<StoreTypeResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/StoreTypes`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationConfigurationRules
   * @request GET:/Calculations/{calculationId}/ConfigurationRules
   * @response `200` `ConfigurationRuleResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationConfigurationRules = (calculationId: number, params: RequestParams = {}) =>
    this.http.request<ConfigurationRuleResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/ConfigurationRules`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationScopeEntityConfigurations
   * @request GET:/Calculations/{calculationId}/ConfigurationRules/ScopeEntityConfigurations
   * @response `200` `ScopeEntityConfigurationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationScopeEntityConfigurations = (calculationId: number, params: RequestParams = {}) =>
    this.http.request<ScopeEntityConfigurationResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/ConfigurationRules/ScopeEntityConfigurations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStoreScheduleExclusions
   * @request GET:/Calculations/{calculationId}/StoreScheduleExclusions
   * @response `200` `StoreScheduleExclusionResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStoreScheduleExclusions = (
    calculationId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<StoreScheduleExclusionResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/StoreScheduleExclusions`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationStoreScheduleExclusionsByStore
   * @request GET:/Calculations/{calculationId}/StoreScheduleExclusions/ByStore
   * @response `200` `StoreScheduleStoreExclusionResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationStoreScheduleExclusionsByStore = (
    calculationId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<StoreScheduleStoreExclusionResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/StoreScheduleExclusions/ByStore`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationValidationProblems
   * @request GET:/Calculations/{calculationId}/ValidationProblems/{area}
   * @response `200` `ValidationProblemResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationValidationProblems = (
    calculationId: number,
    area: ValidationArea,
    params: RequestParams = {},
  ) =>
    this.http.request<ValidationProblemResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/ValidationProblems/${area}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name GetCalculationDepartments
   * @request GET:/Calculations/{calculationId}/Departments
   * @response `200` `CalculationDepartmentResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getCalculationDepartments = (
    calculationId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationDepartmentResponseCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/Departments`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name DeleteRoutes
   * @request DELETE:/Calculations/{calculationId}/SkuRedistributions/Routes
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteRoutes = (
    calculationId: number,
    data: CalculationRoutesDeleteRequest[],
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations/${calculationId}/SkuRedistributions/Routes`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name DeleteSourceStores
   * @request DELETE:/Calculations/{calculationId}/SkuRedistributions/SourceStores
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteSourceStores = (
    calculationId: number,
    data: CalculationSourceStoresDeleteRequest[],
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations/${calculationId}/SkuRedistributions/SourceStores`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name DeleteTargetStores
   * @request DELETE:/Calculations/{calculationId}/SkuRedistributions/TargetStores
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteTargetStores = (
    calculationId: number,
    data: CalculationTargetStoresDeleteRequest[],
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations/${calculationId}/SkuRedistributions/TargetStores`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name DeletePickingPositions
   * @request DELETE:/Calculations/{calculationId}/SkuRedistributions/PickingPositions
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deletePickingPositions = (
    calculationId: number,
    data: CalculationDeletePickingPositionsRequest[],
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations/${calculationId}/SkuRedistributions/PickingPositions`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name BackupSkuRedistribution
   * @request POST:/Calculations/{calculationId}/SkuRedistributions/Backup
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  backupSkuRedistribution = (calculationId: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations/${calculationId}/SkuRedistributions/Backup`,
      method: 'POST',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name RestoreSkuRedistribution
   * @request POST:/Calculations/{calculationId}/SkuRedistributions/Restore
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  restoreSkuRedistribution = (calculationId: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Calculations/${calculationId}/SkuRedistributions/Restore`,
      method: 'POST',
      ...params,
    });
  /**
   * No description
   *
   * @tags Calculations
   * @name SkuRedistributionChangelogs
   * @request GET:/Calculations/{calculationId}/SkuRedistributions/Changelog
   * @response `200` `SkuRedistributionChangelogCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  skuRedistributionChangelogs = (calculationId: number, params: RequestParams = {}) =>
    this.http.request<SkuRedistributionChangelogCollectionResponse, ErrorResponse>({
      path: `/Calculations/${calculationId}/SkuRedistributions/Changelog`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
